export default {
  'image/gif': '.gif',
  'image/png': '.png',
  'image/svg': '.svg',
  'image/jpg': '.jpg',
  'image/jpeg': '.jpg',
};
